import React, { Component } from 'react'
import { auth } from '../helpers/auth'
import { connect } from 'react-redux'
import { signUp } from '../reducers/user'
import { Link } from 'react-router-dom'
import { PrimaryButton } from './Button'

function setErrorMsg(error) {
  return {
    registerError: error.message
  }
}

class Register extends Component {
  state = { registerError: null }
  handleSubmit = (e) => {
    e.preventDefault()
    auth(this.email.value, this.pw.value)
      .then((user) => {

        // Redux event
        this.props.signUp(user)
      })
      .catch(e => this.setState(setErrorMsg(e)))
  }
  render () {
    return (

      <div className=" br2 pv3 ph4 bg-white shadow-custom center mw6 mv6-ns">
        <h1 className="fw2 tc mb4">Sign up for Polaris</h1>
        {
          this.state.registerError &&
          <div className="bg-washed-red pa3 f6 mb3 br2" role="alert">
            {this.state.registerError}
          </div>
        }
        <form onSubmit={this.handleSubmit}>
          <div className="form-group">

            <input className="form-control w-100 mb3 border-box input-reset ba b--black-20 pa3 db br2" ref={(email) => this.email = email} placeholder="Email"/>
          </div>
          <div className="form-group">

            <input type="password" className="form-control w-100 mb3 border-box input-reset ba b--black-20 pa3 db br2" placeholder="Password" ref={(pw) => this.pw = pw} />
          </div>
          <PrimaryButton type="submit" className="btn btn-primary w-100 pv3">Sign up</PrimaryButton>
        </form>
        <p className="tc mv3">Already have an account? <Link className="link blue" to="/login">Sign in</Link></p>
      </div>
    )
  }
}

export default connect(
  (state) => ({
    currentUser: state.user.currentUser,
  }),
  {signUp}
)(Register)



// WEBPACK FOOTER //
// ./src/components/Register.js